import "./customList.css";
import userImg from "../../picture/14.png";
import userImgWhite from "../../picture/userWhite.png";
import plusImg from "../../picture/plus.png";
import sendImg from "../../picture/send.png";
import CheckIcon from "@mui/icons-material/Check";
import { useEffect, useRef, useState } from "react";
import Button from "../../Custom/Button/Button";
import { useGlobalContext } from "../../../Context/Context";
import axios from "axios";
/*
const data = [
  {
    id: 1,
    name: "Petar Petrovic",
    mail: "petarPetrovic@gmail.com",
    isInAccount: true,
    forNotify: false,
    isVisible: false,
  },
  {
    id: 2,
    name: "Jovan Jovanovic",
    mail: "jovanJovanovic@gmail.com",
    isInAccount: true,
    forNotify: false,
    isVisible: false,
  },
  {
    id: 3,
    name: "Petar Jovanovic",
    mail: "petarJovanovic@gmail.com",
    isInAccount: false,
    forNotify: false,
    isVisible: false,
  },
];

const locations = [
  {
    id: 1,
    name: "Moderatorova lokacija",
    isInAccount: true,
    forNotify: false,
  },
  {
    id: 2,
    name: "Druge iz naloga",
    isInAccount: true,
    forNotify: false,
  },
  {
    id: 3,
    name: "Proslava NG",
    isInAccount: false,
    forNotify: false,
  },
  {
    id: 4,
    name: "Trg kralja Milana",
    isInAccount: false,
    forNotify: true,
  },
];
*/

const CustomList = ({
  currentActive,
  setNotificationsList,
  notificationsList,
  setCurrentActive,
  currentNotifaction,
  isEditing,
  setCurrentNotification,
  selectedCompany,
}) => {
  /*
  const handleSetUsers = () => {
    if (isEditing) {
      return data.map((item) => {
        let user = currentNotifaction.notifyUsers.find((u) => u.id === item.id);
        if (user) return { ...item, forNotify: true };
        else return item;
      });
    } else return data;
  };
*/

  const { baseUrl } = useGlobalContext();
  const { loggedUser, apiKey } = useGlobalContext();

  const [users, setUsers] = useState([]);

  const inputRef = useRef();

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleSelectUser = (id) => {
    if (currentActive === 3) {
      setUsers(
        users.map((user) => {
          if (user.id === id) {
            return { ...user, forNotify: !user.forNotify };
          } else return user;
        })
      );
      console.log(users);
    }
    if (currentActive === 4) {
      const currentLocations = users.map((user) => {
        if (id === user.id) return { ...user, forNotify: !user.forNotify };
        else if (id !== user.id && user.forNotify)
          return { ...user, forNotify: !user.forNotify };
        else return user;
      });
      console.log(currentLocations);
      setUsers(currentLocations);
    }
  };

  const handleAddUser = () => {
    if (currentActive === 3) {
      const name = inputRef.current.value;

      if (name === "") return;
      const mail = validateEmail(name);
      console.log(users);
      console.log(mail);
      console.log(name);

      if (mail !== null) {
        if (users.filter((user) => user.mail === mail).length !== 0) return;
        let newUser = {
          name: null,
          id: 0,
          forNotify: false,
          isInAccount: false,
          mail: mail[0],
        };
        try {
          axios
            .post(`${baseUrl}/notifications/createExternalUser.php`, {
              user_email: mail[0],
              user_id: loggedUser.id,
              api_key: apiKey,
              company_id: selectedCompany.company_id,
            })
            .then((response) => {
              const { data } = response;
              console.log(data);
              console.log(newUser);
              console.log("Postavljam user-a");
              newUser = { ...newUser, id: data.id };
              setUsers([...users, newUser]);
              inputRef.current.value = "";
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
    if (currentActive === 4) {
      const name = inputRef.current.value;
      if (name === "") return;

      if (name !== null) {
        if (users.filter((user) => user.name === name).length !== 0) return;

        let newUser = {
          name,
          id: 0,
          forNotify: false,
          isInAccount: false,
          mail: null,
        };
        try {
          axios
            .post(`${baseUrl}/notifications/createExternalLocation.php`, {
              name,
              user_id: loggedUser.id,
              api_key: apiKey,
              company_id: selectedCompany.company_id,
            })
            .then((response) => {
              const { data } = response;
              console.log(data);
              console.log(newUser);
              console.log("Postavljam user-a");
              newUser = { ...newUser, id: data.id };
              setUsers([...users, newUser]);
              inputRef.current.value = "";
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const handleSubmit = () => {
    console.log("Poziva se submit", currentActive, isEditing);
    if (currentActive === 3) {
      if (isEditing) {
        console.log(users);
        console.log(currentNotifaction);
        let notifyUsers = users;
        console.log(notifyUsers);
        setCurrentNotification({ ...currentNotifaction, notifyUsers });
        setNotificationsList(
          notificationsList.map((notification) => {
            return {
              ...notification,
              notifyUsers: users,
            };
          })
        );
        setCurrentActive(0);
      } else {
        setNotificationsList(
          notificationsList.map((notification) => {
            return {
              ...notification,
              notifyUsers: users,
            };
          })
        );
        setCurrentActive(4);
      }
    }
    if (currentActive === 4) {
      if (isEditing) {
        console.log(users, isEditing);
        //let location = users.find((user) => user.forNotify);
        setCurrentNotification({ ...currentNotifaction, location: users });
      }
      setNotificationsList(
        notificationsList.map((notification) => {
          return {
            ...notification,
            location: users,
          };
        })
      );

      setCurrentActive(0);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      console.log(selectedCompany);
      console.log(notificationsList[0])
      if (currentActive === 3) {
        if (isEditing) {
          let newData;
          console.log(notificationsList[0]);
          newData = notificationsList[0].notifyUsers.map((item) => {
            return item;
          });
          setUsers(newData);
        } else {
          /*console.log(
            "Pribavlja user-a iz baze",
            notificationsList[0].notifyUsers
          );*/
          if (notificationsList != undefined && notificationsList[0].notifyUsers.length === 0) {
            try {
              const response = await axios.post(
                `${baseUrl}/notifications/readUsersCompanyId.php`,
                {
                  user_id: loggedUser.id,
                  api_key: apiKey,
                  company_id: selectedCompany.company_id,
                }
              );
              const { data } = response;
              if (data.status === 200) {
                setUsers(data.data);
              }
              console.log(data);
            } catch (error) {
              if (error.response.status === 404) {
                // not found
              }
            }
          } else {
            setUsers(notificationsList[0].notifyUsers);
          }
        }
      } else {
        if (isEditing) {
          let newData;
          console.log(notificationsList[0]);
          newData = notificationsList[0].location.map((item) => {
            return item;
          });
          setUsers(newData);
        } else {
          if (notificationsList[0].location.length === 0) {
            try {
              const response = await axios.post(
                `${baseUrl}/notifications/readLocationsByCompanyId.php`,
                {
                  user_id: loggedUser.id,
                  api_key: apiKey,
                  company_id: selectedCompany.company_id,
                }
              );
              const { data } = response;
              if (data.status === 200) {
                setUsers(data.data);
              }
              console.log(data);
            } catch (error) {
              if (error.response.status === 404) {
                // not found
              }
            }
          } else {
            setUsers(notificationsList[0].location);
          }
        }
      }
    };
    fetchData();
  }, []);

  return (
    <div className="custom-list">
      <div className="custom-list-content">
        {users.map((user) => {
          const { id, name, forNotify, isInAccount, mail } = user;

          return (
            <div className="custom-list-item" key={id}>
              <img src={isInAccount ? userImg : userImgWhite} alt="" />
              <span
                className={
                  currentActive === 3
                    ? "custom-list-item-name"
                    : "custom-list-item-name italic"
                }
              >
                {name === null ? mail : name}
              </span>
              <div
                className={
                  forNotify ? "custom-list-check checked" : "custom-list-check"
                }
                onClick={() => handleSelectUser(id)}
              >
                <CheckIcon style={{ height: "100%", width: "100%" }} />
              </div>
            </div>
          );
        })}
      </div>
      <div className="custom-list-add">
        <div className="custom-list-add-top">
          <input ref={inputRef} />
          <div className="custom-list-add-img" onClick={handleAddUser}>
            <Button activation={true} image={plusImg} />
          </div>
        </div>
        <div className="custom-list-add-btn" onClick={handleSubmit}>
          <Button image={sendImg} />
        </div>
      </div>
    </div>
  );
};

export default CustomList;
